import Vue from 'vue';
import Vuex from 'vuex';
import { getToDoList } from '../../lib/flow'
import session from './session'
import ajax from '@/lib/ajax';
Vue.use(Vuex);

const todoCount = {
  state: { 
    fileCount: '',
    projectCount: '',
    depositCount: '',
    QRCount: '',
    FQCount: '',
    FPCount: '',
    ZJQRCount: '',
    ZXQRCount: '',
    secretCount: '',
    expertFeeCount: '',
    expertOtherCount: '',
    enrollCount: ''
  },
  mutations: {
    fileCount (state:any, param:any) {
      state.fileCount = param
    },
    projectCount (state:any, param:any) {
      state.projectCount = param
    },
    depositCount (state:any, param:any) {
      state.depositCount = param
    },
    QRCount (state:any, param:any) {
      state.QRCount = param
    },
    FQCount (state:any, param:any) {
      state.FQCount = param
    },
    FPCount (state:any, param:any) {
      state.FPCount = param
    },
    ZJQRCount (state:any, param:any) {
      state.ZJQRCount = param
    },
    ZXQRCount (state:any, param:any) {
      state.ZXQRCount = param
    },
    secretCount (state:any, param:any) {
      state.secretCount = param
    },
    expertFeeCount (state:any, param:any) {
      state.expertFeeCount = param
    },
    expertOtherCount (state:any, param:any) {
      state.expertOtherCount = param
    },
    enrollCount (state:any, param:any) {
      state.enrollCount = param
    }
  },
  actions: {
    async todoCount(params:any) {
      let user:any = session.state.user
      // 文件审核
      getToDoList(user.phoneNumber, { whereStr: `AppId='CG'` }).then((res:any) => {
        getToDoList(user.phoneNumber, { whereStr: `AppId='FS'` }).then((rep:any) => {
          params.state.fileCount = res.total + rep.total
        })
      })
      // 保密办审核(权限)
      getToDoList(user.phoneNumber, { whereStr:"AppId='NP' and BusinessKey='secret'" }).then((res:any) => {
        params.state.secretCount = res.total
      })
      // 线上提成 
      getToDoList(user.phoneNumber, { page: 1, size: 1, whereStr: `AppId='QR'` }).then((res:any) => {
        params.state.QRCount = res.total
      })
      // 湛江2021线上提成 
      getToDoList(user.phoneNumber, { page: 1, size: 1, whereStr: `AppId='QR' and BusinessKey like'%湛江-20%'` }).then((res:any) => {
        params.state.ZJQRCount = res.total
      })
      // 咨询事业部2021线上提成 
      getToDoList(user.phoneNumber, { page: 1, size: 1, whereStr: `AppId='QR' and BusinessKey like'%咨询事业部-20%'` }).then((res:any) => {
        params.state.ZXQRCount = res.total
      })
      //  线下提成 
      getToDoList(user.phoneNumber, { page: 1, size: 1, whereStr: `AppId='FQ'` }).then((res:any) => {
        params.state.FQCount = res.total
      })
      //  提成发放申报 
      getToDoList(user.phoneNumber, { page: 1, size: 1, whereStr: `AppId='FP'` }).then((res:any) => {
        params.state.FPCount = res.total
      })
      // 项目立项
      getToDoList(user.phoneNumber, { page: 1, size: 1, whereStr: `AppId='NP'` }).then((res:any) => {
        params.state.projectCount = res.total
      })
      // 退保审核
      getToDoList(user.phoneNumber, { page: 1, size: 1, whereStr: `AppId='RM'` }).then((res:any) => {
        params.state.depositCount = res.total
      })
      // 专家费借支
      let zrep = await ajax.get('/api/services/app/ClProjectDb/GetPaged', {
        params: {
          flowLogReviewPerson: user.name,
          needOtherFillter: false,
          filter: '(projectState == "已挂网文件售卖中" or projectState == "项目失败" or projectState == "开评标中" or projectState == "已开评标完" or projectState == "项目结项") and clMeetingRoom.id> "0"',
          sorting: 'newProjectTime desc',
          maxResultCount: 1
        }
      })
      params.state.expertFeeCount = zrep.data.result.totalCount
      // 专家费借支（其他）
      let rep = await ajax.get('/api/services/app/AbpArgument/GetPaged', {
        params: {
          flowLogReviewPerson: user.name,
          filter: '',
          sorting: 'creationTime desc',
          maxResultCount: 1,
          skipCount: 0
        }
      })
      params.state.expertOtherCount = rep.data.result.totalCount
      // 报名审核
      let filter = ''
      user.selectDistrict.split(',').forEach((item:any) => {
        filter += ` or e.district == "${item}"`
      })
      filter = filter.slice(3)
      ajax.get('api/services/app/AbpEnroll/GetPaged', {
        params: {
          maxResultCount: 1,
          skipCount: 0,
          filter: `(${filter}) and e.status == "4"`
        }
      }).then(res => {
        params.state.enrollCount = res.data.result.totalCount
      })
    }
  }
}
export default todoCount;